"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavHeading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NavHeading = ({ children }) => {
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "type--kicker type--base075 mb--0_5 ml--1_5" }, { children: children }), void 0);
};
exports.NavHeading = NavHeading;
//# sourceMappingURL=NavHeading.js.map